import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi, postApi } from "../../../services/apiServices";
import { ALL_PRODUCTS } from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

/*---------------- Get All Products ---------------- */
export const AllProductsAPI = createAsyncThunk(
  "all_products/admin",
  async (reqData) => {
    try {
      // FIX: Extract all parameters including page and per_page
      const {
        dealer_code,
        page = 1,
        per_page = 20,
        search = "",
        responsibility_center,
      } = reqData;

      const response = await postApi(ALL_PRODUCTS, {
        dealer_code,
        page,
        per_page,
        search,
        responsibility_center,
      });

      return response;
    } catch (error) {
      console.log("Error All ProductsAPI", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);

export const AllProductsSearchAPI = createAsyncThunk(
  "all_products/admin",
  async (reqData, payload) => {
    try {
      // const { dealer_code } = reqData;
      console.log("The payload is:", reqData);
      const response = await postApi(ALL_PRODUCTS, { payload });
      return response;
    } catch (error) {
      console.log("Error All ProductsAPI", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  },
);
